// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VeeValidate from 'vee-validate'
import * as filters from '@/filters'
import * as mixins from '@/mixins'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueDraggable from 'vue-draggable'
import VueStripeCheckout from 'vue-stripe-checkout'
import VTooltip from 'v-tooltip'
import GSignInButton from 'vue-google-signin-button'
// import "@/plugins/vueMeta"
// import VueHead from 'vue-head'
import i18n from './plugins/i18n.js'
import '@/api/config.js'
import store from '@/store'

import '@/static/css/style.css'
import '@/static/css/custome.scss'
import 'element-ui/lib/theme-chalk/base.css'
// import './registerServiceWorker'

import locale from 'element-ui/lib/locale/lang/en'

Vue.use(VTooltip)
Vue.use(VeeValidate, { inject: false })
Vue.use(VueDraggable)
Vue.use(VueStripeCheckout, process.env.STRIPE_KEY)
Vue.use(GSignInButton)
Vue.config.productionTip = false
Vue.prototype.$eventBus = new Vue()
// Vue.use(VueHead, {
//   separator: ' ',
// })

// element-ui
Vue.use(ElementUI, { locale })
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAP_KEY,
    libraries: 'places'
  }
})
// custom filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// common mixins
Object.keys(mixins).forEach(key => {
  Vue.mixin(mixins[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js